import { FCMTOKEN } from "../configs/api";
import * as serviceContext from "./serviceContext";

var options = {};
var headers = new Headers();

headers.append("Content-Type", "application/json");
options.headers = headers;

export async function loginUser(userData) {
  try {
    // userData.fcmToken = FCMTOKEN;
    const response = await serviceContext.post(`/MobileLogin`,userData,options);
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
}

export async function logoutUser(data) {
  try {
    const response = await serviceContext.post(`/MobileLogout`, data, options);
    return response;
  } catch (error) {
    return error;
  }
}
